import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Main from './Main/Main.jsx';
import Listing from './Listing/Listing.jsx';
import Search from './Search.jsx';
import ClickableCanvas from './Canvas.jsx';
import Report from './Report/Report.jsx';
import Inspection from './Inspection/Inspection.jsx';

const NotFound = () => <h1>Page Not Found</h1>;

export default function Contents() {
  const [hist, setHist] = useState(0);
  const [price, setPrice] = useState(0);
  const [mile, setMile] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');

  const saveState = (hist, price, mile, searchTerm) => {
    setHist(hist);
    setPrice(price);
    setMile(mile);
    setSearchTerm(searchTerm);
  } 
  return (
    <Routes>
      <Route exact path="/" element={<Navigate to="/main" replace />} />
      <Route path="/main" element={<Main />} />
      <Route path="/listing" element={<Listing prevHist={hist} prevPrice={price} prevMile={mile} prevSearch={searchTerm} saveState={saveState}/>} />
      <Route path="/report" element={<Report />} />
      <Route path="/report/:id" element={<Report />} />
      <Route path="/inspection" element={<Inspection />} />
    </Routes>
  );
}
